// extracted by mini-css-extract-plugin
module.exports = {"blue":"#168fce","pink":"#e2048c","hoverBg":"#fef8fb"};